export default {
  ODOMETER: "Odomètre",

  KM: "Kilomètre",
  MILES: "Miles",
};
